// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1wIBZ{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;height:40px;height:4rem;justify-content:center;overflow:hidden;width:40px;width:4rem}._3Cgzp{background-color:transparent;border:1px dashed #c9cfdc}._1SfL3{max-height:100%;width:auto}._15HA3{color:#fff;display:block;font-size:15px;font-size:1.5rem;font-weight:700}", ""]);
// Exports
exports.locals = {
	"avatar": "_1wIBZ",
	"avatar--inactive": "_3Cgzp",
	"avatar__img": "_1SfL3",
	"avatar__initials": "_15HA3"
};
module.exports = exports;
